export default __webpack_public_path__ + "_/shared_modules/common-images/loantype-joint-b830dec43f740c25cd013cca4baaa327.svg";